import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1ForWho() {
  const forWho = ['Persoane care simt că au atins un plafon. Au citit, au învățat, dar viața nu se mișcă. Vor lucru profund cu cineva care îi ghidează personal.', 'Oameni care trec printr-o perioadă dificilă — schimbare în carieră, separare, doliu, anxietate — și vor susținere reală, nu doar tehnici teoretice.', 'Persoane care au făcut deja cursurile Academiei și vor să accelereze transformarea cu lucru individual pe teme specifice.', 'Oameni care au nevoie de intimitate și siguranță într-un spațiu fără grup, în care pot să se deschidă complet, fără să se cenzureze.'];
  const notForWho = ['Persoane care caută o "vindecare" pasivă, fără să își asume nimic. Theta Healing® funcționează în co-creație. Tu pui energia, eu te ghidez.', 'Cei care vor rezultate într-o singură ședință pentru probleme adunate în decenii. Schimbările apar, dar lucrul profund cere mai mult timp.', 'Oameni complet închiși la dimensiunea spirituală sau energetică. Theta Healing® lucrează cu stări modificate de conștiință și conexiune interioară.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1721">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1722">
        <SectionHeading title="Pentru cine sunt ședințele 1 la 1" data-id="element-1723" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1724">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-1725">
            <div className="flex items-center gap-4 mb-8" data-id="element-1726">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1727">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-1728" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1729">
                Sunt pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1730">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1731">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-1732" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1733">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-1734">
            <div className="flex items-center gap-4 mb-8" data-id="element-1735">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1736">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-1737" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1738">
                NU sunt pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1739">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1740">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-1741" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1742">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1743">
          <CTAButton data-id="element-1744" />
        </motion.div>
      </div>
    </section>;
}